import { render, staticRenderFns } from "./ObservationEvidenceForm.vue?vue&type=template&id=c2199f80&scoped=true"
import script from "./ObservationEvidenceForm.vue?vue&type=script&lang=js"
export * from "./ObservationEvidenceForm.vue?vue&type=script&lang=js"
import style0 from "./ObservationEvidenceForm.vue?vue&type=style&index=0&id=c2199f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2199f80",
  null
  
)

export default component.exports